import * as _ from 'lodash';
import React, {
  useRef, useMemo,
} from 'react';
import PropTypes from 'prop-types';
import { useOutsideClick } from '@common/hooks/outsideClick';
import { useTranslation } from '@common/hooks/translation';

import Config from '@app/dev/config/main';
import FlipMove from 'react-flip-move';

const PROVIDER_TOGGLE_VIEW_COUNT = 6;

export const Providers = ({
  providers, toggleProvider, selectedProviders, providerExpanded, setProiderExpanded,
}) => {
  const t = useTranslation();
  const scrollerElem = useRef();

  const closeExpanded = (provider, state = false, ignoreConfig = false) => {
    if (!ignoreConfig && !Config.sportsbook.competitionList?.closeAfterSelect) return;

    setProiderExpanded(state);
    if (scrollerElem.current) scrollerElem.current.scrollTop = 0;
  };

  const wrapperRef = useOutsideClick(() => providerExpanded && closeExpanded(), [providerExpanded]);

  const sortedCompetitionList = useMemo(() => {
    const [selectedProvidersList, leftProvidersList] = _.partition(providers, (item) => selectedProviders.includes(item.name));

    return selectedProvidersList.concat(leftProvidersList);
  }, [selectedProviders, providers]);

  return (
    <div
      className={`providers ${providerExpanded ? 'list-expanded' : ''}`}
      ref={wrapperRef}
      onClick={() => providerExpanded && setProiderExpanded(false)}
    >
      <div className="inner-move-cont">
        <FlipMove>
          <div className="innerWrapper" onClick={(e) => e.stopPropagation()}>

            {sortedCompetitionList.map((item) => (
              <div
                onClick={(e) => {
                  toggleProvider(item.name);
                  e.stopPropagation();
                }}
                key={item.name}
                className={`providerItem ${selectedProviders.includes(item.name) ? 'active' : ''}`}
              >
                {t(item.title)}
              </div>
            ))}

          </div>
        </FlipMove>
        {providers?.length > PROVIDER_TOGGLE_VIEW_COUNT && (
          <i
            aria-hidden="true"
            onClick={() => setProiderExpanded(!providerExpanded)}
            className={`global-icon ${providerExpanded ? 'icon-arrow-up4' : 'icon-arrow-down5'} asian-list-icon c-s`}
          />
        )}
      </div>
    </div>
  );
};

Providers.propTypes = {
  providers: PropTypes.array,
  providerParam: PropTypes.object,
  categorieId: PropTypes.string,
  toggleProvider: PropTypes.func,
  selectedProviders: PropTypes.array,
};
